import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {IconButton} from '@components/common/base/buttons'
import {useListStore} from '@components/common/sandbox/list-view/list-store'
import {Identifiable, NullableId, RowConfig} from '@components/common/sandbox/list-view/types'

const TwIconButton = tw(IconButton)<{
  $isTaskColored?: boolean
  $isCompleted?: boolean
  $isOpen?: boolean
  $forceVisible?: boolean
}>`
  relative
  !w-12 !h-20 flex justify-center items-center border border-solid rounded-[7px]
  ${({ $isOpen, $forceVisible }) => $isOpen || $forceVisible ? '' : 'invisible group-hover:visible'}
  ${p => {
  if (p.$isTaskColored) {
    return `!text-icon-primary ${
      p.$isCompleted
        ? 'opacity-[.38] hover:opacity-[.64] active:opacity-[.64]'
        : 'opacity-[.64] hover:opacity-100 active:opacity-100'
    }`
  }

  return `hover:!text-action-hover active:!text-action-pressed ${
    p.$isCompleted ? '!text-placeholder-new' : ''
  }`
}}
`

interface ItemMenuProps<TData extends Identifiable> {
  row: RowConfig<TData>,
  parentId: NullableId,
  isDone: boolean,
  forceShow?: boolean
}

export const ItemMenuButton = observer(<TData extends Identifiable>(props: ItemMenuProps<TData>) => {
  const {
    row,
    parentId,
    isDone,
    forceShow = false
  } = props;
  const buttonRef = React.useRef<HTMLButtonElement>(null)
  const [isMenuOpen, setMenuOpen] = useState(false)
  const store = useListStore()
  const { config, exposedApi } = store

  const openMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    store.setActiveItem(row.data.id);
    setMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    store.setActiveItem(null);
    setMenuOpen(false)
  }

  return (
    <>
      <TwIconButton
        ref={buttonRef}
        data-test="board-task-menu"
        icon={'IconCustomDotsVerticalNoPadding'}
        color="secondary"
        size="small"
        wrapperSize="big"
        forcedState={isMenuOpen ? 'active' : undefined}
        onClick={openMenu}
        $isTaskColored
        $isCompleted={isDone}
        $isOpen={isMenuOpen}
        $forceVisible={forceShow}
      />
      {isMenuOpen && buttonRef.current && config.renderItemMenu(buttonRef.current, row, parentId, exposedApi, closeMenu)}
    </>
  )
})